// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { KpiBoxes, type KpiBoxesProps } from '@shared/ui-kit/components';
import { formatToMoney } from '@advisor-app/features/utils/format-to-money';
import { numberToFixed } from '@shared/ui-kit/utils';

interface KpisRebalanceProps {
  kpisData: KpiBoxesProps[];
}

export const KpisRebalance = ({ kpisData }: KpisRebalanceProps): JSX.Element => {
  return (
    <div className="grid grid-cols-4 gap-6">
      {kpisData.map(data => {
        return (
          <KpiBoxes
            key={data.text}
            value={formatToMoney(numberToFixed(data.value as number, 0))}
            text={data.text}
            numberPositions={data.numberPositions}
            popupName={data.popupName}
            icon={data.icon}
            color={data.color}
          />
        );
      })}
    </div>
  );
};
